export const checkIsArray = (array?: Array<unknown>) =>
  Boolean(Array.isArray(array) && array.length)
